import React from "react";
import { Link } from "../../utils/customLink";
import ArrowRight from "../../images/icons/arrow-right.inline.svg";
import ArrowRightBigIcon from "../../images/icons/arrow-right-big-icon.inline.svg";
import DownloadSvg from "../../images/icons/download-icon.inline.svg";

const OnlineHeroContent = ({
  pageTitle,
  courseTitle = "Online course",
  applyNow,
  content,
  courseBrochure,
  programCode
}) => {
  return (
    <>
      <h1
        className="font-body font-light text-white leading-[46px]"
        dangerouslySetInnerHTML={{ __html: courseTitle }}
      />

      <h1
        className="text-[34px] md:text-[4rem] font-normal text-white leading-[2rem] md:leading-[73px] text-left md:w-[60%] pb-9"
        dangerouslySetInnerHTML={{ __html: pageTitle }}
      />
      <div className="flex flex-col md:flex-row gap-3 w-full md:w-auto">
        <a
          className="callback-button group flex justify-center items-center md:px-20 py-2 bg-white hover:bg-black-lighter hover:text-white planet:bg-transparent planet:hover:bg-white planet:hover:text-gray-darker"
          href={courseBrochure}
          target={"_gviblank"}
        >
          <div
            className="pr-2"
            dangerouslySetInnerHTML={{ __html: "Download course info" }}
          />
          <DownloadSvg className="w-5 pr-1 fill-black-lighter group-hover:fill-white planet:fill-white planet:group-hover:fill-gray-darker" />
        </a>
        <Link
          className="submit-button group flex justify-center items-center px-20 py-2"
          to={`${
            applyNow ??
            `/application-form/?online_program&program_id=${programCode}`
          }`}
        >
          <div
            className="pr-2 font-bold"
            dangerouslySetInnerHTML={{ __html: "Apply" }}
          />
          <ArrowRightBigIcon className="planet:hidden fill-white group-hover:fill-black-lighter" />
          <ArrowRight className="hidden planet:block w-3 h-3 stroke-gray-darker group-hover:stroke-green-standard" />
        </Link>
      </div>
    </>
  );
};

export default OnlineHeroContent;
